import { WhiteboardDrawing } from './whiteboard-drawing';
import { Modalable, ResponseStatus } from './modalable';

export class ModalableWhiteboardDrawing extends WhiteboardDrawing implements Modalable {
    static MODAL_ID = 'whiteboardDrawingModal';
    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return ModalableWhiteboardDrawing.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return true;
    }

    asWhiteboardDrawing(): WhiteboardDrawing {
        return this;
    }
}
